// ./src/components/features/AnalyticsConsent/useAnalyticsConsent.ts
//
// This browser's analytics choice, live — shared by the one-time banner and the profile switch, so answering in one
// updates the other at once (ROADMAP #62 P7). The rules are in `utils/analytics/consent.ts`.
import { useEffect, useMemo, useState } from 'react';

import {
  AnalyticsConsent,
  analyticsEnabled,
  browserTimeZone,
  effectiveConsent,
  needsConsentPrompt,
  privacySignalOn,
  readStoredConsent,
  setAnalyticsConsent,
  subscribeConsent,
} from '@/utils/analytics';

export interface UseAnalyticsConsentReturn {
  /** False when this build collects nothing — then there is nothing to ask about. */
  enabled: boolean;
  /** What applies now: the answer given on this browser, else the default for its clock. */
  consent: AnalyticsConsent;
  /** Show the one-time banner? */
  needsPrompt: boolean;
  setConsent: (consent: AnalyticsConsent) => void;
}

export const useAnalyticsConsent = (): UseAnalyticsConsentReturn => {
  const [stored, setStored] = useState<AnalyticsConsent | null>(() => readStoredConsent());
  const timeZone = useMemo(() => browserTimeZone(), []);

  useEffect(() => subscribeConsent(setStored), []);

  return {
    enabled: analyticsEnabled,
    consent: effectiveConsent(stored, timeZone, privacySignalOn()),
    needsPrompt: analyticsEnabled && needsConsentPrompt(stored, timeZone),
    setConsent: setAnalyticsConsent,
  };
};
